import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for   Deletebacktestvalues
export const Deletebacktestvalues = createSlice({
  name: "Deletebacktestvalues",
  initialState: {
    api_completed: false,
    isLoading: false,
    isSuccess: false,
    switch: false,
    data: {},
  },
  reducers: {
    Deletebacktestvalues_datagrid: (state, a) => {
      state.data = a.payload;
      state.switch = true
    },
    success_api_call_Deletebacktestvalues_datagrid: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
    },
    failure_api_call_Deletebacktestvalues_datagrid: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.api_completed = true;
    },
    Deletebacktestvalues_datagrid_is_success: (state, action) => {
      state.isSuccess = false;
    },
    create_Deletebacktestvalues_datagrid_complete_api: (state, action) => {
      state.api_completed = false;
    },
    false_switchDeletebacktestvalues:(state)=>{
        state.switch = false
    }
  },
});
export default Deletebacktestvalues.reducer;
export const {
  Deletebacktestvalues_datagrid,
  success_api_call_Deletebacktestvalues_datagrid,
  failure_api_call_Deletebacktestvalues_datagrid,
  create_Deletebacktestvalues_datagrid_complete_api,
  Deletebacktestvalues_datagrid_is_success,false_switchDeletebacktestvalues
} = Deletebacktestvalues.actions;
